
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import DateService from '@/apps/shared/utils/formatDate';

    export default Vue.extend({
        name: 'TravelAssistanceSummary',
        components: {
            XSummary,
        },
        data() {
            return {
                productDetails: {
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    firstPaymentFeeUsd: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/asistencia-viajero' },
                        { text: 'Resumen', path: '/asistencia-viajero/resumen' },
                    ],
                    icon: {
                        src: '/Logos/asistencia-al-viajero.svg',
                        alt: 'Asistencia al Viajero',
                        title: 'Asistencia al Viajero'
                    },
                    product: '/asistencia-viajero'
                } as SummaryDetails,
                GUiD: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'summary';

                const planData = JSON.parse(sessionStorage.getItem("SelectedTravelPlan"));
                const contratante = JSON.parse(sessionStorage.getItem("contratante"));
                const travelData = JSON.parse(sessionStorage.getItem("TravelDetailsData"));

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = contratante ? contratante.lastName : '';
                request.firstName = contratante ? contratante.firstName : '';
                request.phone = contratante ? contratante.areaCode + contratante.telephone : '';
                request.mail = contratante ? contratante.email : '';
                request.quotePlan = planData ? planData.name : '';
                request.quotationDetail = "Producto: Asistencia al Viajero"
                    + " - Destino: " + (travelData && travelData.destination ? travelData.destination.description : '')
                    + " - Pasajeros: " + (travelData ? travelData.passengersCount : '');

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            formatDateFromSession(dateValue) {
                if (!dateValue) return '';
                var d = new Date(dateValue);
                if (isNaN(d.getTime())) return '';
                return DateService.formatDate(d);
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const contratante = JSON.parse(sessionStorage.getItem('contratante'));
                const planSelected = JSON.parse(sessionStorage.getItem('SelectedTravelPlan'));
                const travelData = JSON.parse(sessionStorage.getItem('TravelDetailsData'));

                // Fechas de vigencia (salida / regreso)
                if (travelData) {
                    this.productDetails.effectDate = this.formatDateFromSession(travelData.departureDate);
                    this.productDetails.expirationDate = this.formatDateFromSession(travelData.returnDate);
                }

                // Datos del contratante
                if (contratante) {
                    this.productDetails.name = contratante.firstName + ' ' + contratante.lastName;
                    this.productDetails.email = contratante.email;
                    this.productDetails.telephone = contratante.areaCode + '-' + contratante.telephone;
                }

                // Datos del plan
                if (planSelected) {
                    this.productDetails.planDescription = planSelected.name;

                    this.productDetails.firstPaymentFee = planSelected.premioSegunVigenciaPesosACobrar
                        ? Number(planSelected.premioSegunVigenciaPesosACobrar).toLocaleString('es-AR', { maximumFractionDigits: 0 })
                        : '';
                    // Valor informativo en USD (el producto se tarifa en dólares).
                    this.productDetails.firstPaymentFeeUsd = planSelected.priceFormatted || '';
                    this.productDetails.capital = null;
                    this.productDetails.undiscountedPrice = null;
                    this.productDetails.rate = null;
                    this.productDetails.cover = planSelected.covers
                        ? planSelected.covers.filter(c => c.included).map(c => ({ coverDescription: c.description }))
                        : [];
                }
            },

            setSessionParams() {
                const rawContratante = JSON.parse(sessionStorage.getItem('contratante'));
                const rawPlanSelected = JSON.parse(sessionStorage.getItem('SelectedTravelPlan'));
                const rawTravelData = JSON.parse(sessionStorage.getItem('TravelDetailsData'));
                const rawPassengers = JSON.parse(sessionStorage.getItem('passengers'));
                const rawLeadId = JSON.parse(sessionStorage.getItem('LeadId'));
                const rawDataTabHome = JSON.parse(sessionStorage.getItem('DataTabHome'));

                const payload = {
                    productId: 1018,
                    pricingId: rawPlanSelected
                        ? (Array.isArray(rawPlanSelected.pricingId) ? rawPlanSelected.pricingId[0] : rawPlanSelected.pricingId)
                        : null,
                    leadId: rawLeadId,
                    contratante: {
                        firstName: rawContratante ? rawContratante.firstName : '',
                        lastName: rawContratante ? rawContratante.lastName : '',
                        documentNumber: rawContratante ? rawContratante.documentNumber : '',
                        documentType: rawContratante ? rawContratante.documentType : null,
                        areaCode: rawContratante ? rawContratante.areaCode : '',
                        telephone: rawContratante ? rawContratante.telephone : '',
                        email: rawContratante ? rawContratante.email : '',
                        ivaCondition: rawContratante ? rawContratante.ivaCondition : null,
                    },
                    plan: {
                        name: rawPlanSelected ? rawPlanSelected.name : '',
                        priceFormatted: rawPlanSelected ? rawPlanSelected.priceFormatted : '',
                    },
                    travelData: {
                        destination: rawTravelData ? rawTravelData.destination : null,
                        tripType: rawTravelData ? rawTravelData.tripType : null,
                        departureDate: rawTravelData ? rawTravelData.departureDate : null,
                        returnDate: rawTravelData ? rawTravelData.returnDate : null,
                        passengersCount: rawTravelData ? rawTravelData.passengersCount : 0,
                    },
                    passengers: rawPassengers || [],
                    referente: this.referente,
                };

                const jsonString = JSON.stringify(payload);

                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            getCUPE() {
                const email = "";
                const productId = 1018;
                NF.UI.Page.block();
                return CUPEService.GetCUPEUrl(productId, email, this.GUiD)
                    .then(response => {
                        this.productDetails.cupeUrl = response.preferenceMessage;
                    })
                    .catch((error) => {
                        console.error('Error al obtener la URL:', error);
                    })
                    .finally(() => NF.UI.Page.unblock());
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData(),
                    this.setSessionParams()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);


                await this.getCUPE();

                // GTM checkout event
                const contratante = JSON.parse(sessionStorage.getItem('contratante'));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': contratante ? contratante.email : null,
                    'product': 'asistencia-viajero',
                    'event': 'cotizador-viajero-checkout',
                    'referente': this.referente
                });

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
